<script setup lang="ts">
import { Annotation } from '@/@types/order'

import { Stepper, StepperDescription, StepperItem, StepperSeparator, StepperTitle, StepperTrigger } from '@/components/ui/stepper'
import { formatDistance } from 'date-fns'
import { ptBR } from 'date-fns/locale'

defineProps<{
    annotations: Annotation[]
}>()
</script>

<template>
    <Stepper orientation="vertical" class="flex w-full flex-col justify-start gap-12 overflow-hidden">
        <StepperItem
            v-for="(annotation, index) in annotations"
            :key="annotation.id"
            class="relative flex w-full items-start gap-5 pb-4"
            :step="index + 1"
        >
            <StepperSeparator
                v-show="annotations.length - 1 !== index"
                class="absolute top-[48px] left-[23px] block h-[100%] w-0.5 shrink-0 rounded-full bg-gray-200 group-data-[disabled]:bg-gray-200 group-data-[disabled]:opacity-100"
            />

            <StepperTrigger class="relative">
                <div class="flex size-10 items-center justify-center rounded-[18px] bg-gray-400">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M10 9C11.6569 9 13 7.65685 13 6C13 4.34315 11.6569 3 10 3C8.34315 3 7 4.34315 7 6C7 7.65685 8.34315 9 10 9Z"
                            fill="white"
                        />
                        <path d="M3 18C3 14.134 6.13401 11 10 11C13.866 11 17 14.134 17 18H3Z" fill="white" />
                    </svg>
                </div>
                <svg class="absolute -right-2 -bottom-2" width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 4C0 1.79086 1.79086 0 4 0H24V22H0V4Z" fill="white" />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20 6V14C20 15.1046 19.1046 16 18 16H13L8 20V16H6C4.89543 16 4 15.1046 4 14V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6ZM9 9H7V11H9V9ZM11 9H13V11H11V9ZM17 9H15V11H17V9Z"
                        fill="#9CA3AF"
                    />
                </svg>
            </StepperTrigger>

            <div class="flex w-full flex-col justify-between gap-1">
                <div class="flex flex-col gap-1">
                    <StepperTitle class="font-semibold whitespace-break-spaces text-slate-800 transition lg:text-base">
                        {{ annotation.user.name }}
                    </StepperTitle>
                    <time :datetime="new Date(annotation.created_at).toISOString()" class="font-sans text-xs text-gray-600 lg:text-sm">
                        Comentou
                        {{ formatDistance(new Date(annotation.created_at), new Date(), { addSuffix: true, locale: ptBR }) }}
                    </time>
                </div>

                <StepperDescription class="m text-xs text-gray-700 transition lg:text-sm">
                    {{ annotation.comment }}
                </StepperDescription>
            </div>
        </StepperItem>
    </Stepper>
</template>
